<div class="nav-container col">
  <!-- face button -->
  <div class="dropdown">
    <button
      type="button"
      class="btn btn-primary btn-circle btn-sm d-none d-md-block p-0"
      id="dropdownMenu2"
      [class]="profilePhoto ? 'avatar' : ''"
      [ngStyle]="getAvatar()"
      (click)="toggleProfileDropdown($event)"
    >
      <app-icon *ngIf="!profilePhoto" name="smile"></app-icon>
    </button>
    <ul
      #profileDropdown
      class="dropdown-menu dropdown-profile mt-3"
      aria-labelledby="dropdownMenu2"
      [class]="profileDropdownOpen ? 'd-block' : 'd-none'"
    >
      <li *ngIf="isImplemented && userRole !== UserRole.Unaffiliated">
        <a
          class="dropdown-item text-muted"
          [routerLink]="profileLink"
        >
          <app-icon name="profile"></app-icon>
          {{ "NAVIGATION.EDIT_PROFILE" | translate }}
        </a>
      </li>
      <li *ngIf="userRole === UserRole.Student && theme !== 'light'">
        <a (click)="themeService.changeTheme('light')"
            class="dropdown-item text-muted">
          <app-icon [name]="'light-mode'"></app-icon>
          {{ 'NAVIGATION.LIGHT_MODE' | translate }}
        </a>
      </li>
      <li *ngIf="userRole === UserRole.Student && theme === 'light'">
        <a (click)="themeService.changeTheme('dark')"
            class="dropdown-item text-muted">
          <app-icon [name]="'dark-mode'"></app-icon>
          {{ 'NAVIGATION.DARK_MODE' | translate }}
        </a>
      </li>
      <li>
        <hr *ngIf="userRole !== UserRole.Unaffiliated" class="my-2" />
      </li>
      <li>
        <a class="dropdown-item text-muted" (click)="onLogout()">
          <app-icon name="log-out"></app-icon>
          {{ "BUTTON.LOG_OUT" | translate }}
        </a>
      </li>
    </ul>
  </div>
  <div
    class="d-none d-xl-flex flex-column  mb-2 pe-3 border-end border-primary text-start"
    id="profileName"
  >
    <span class="small">{{ getFullName() }}</span>
    <span class="xsmall text-muted"> {{ getRole() }}</span>
  </div>
  <!-- notifications button  -->
  <div class="dropdown">
    <button
      type="button"
      class="btn btn-primary btn-circle d-none d-md-block ms-3"
      id="notifications"
      (click)="toggleNotificationsDropdown($event)"
    >
      <app-icon name="notification-white"></app-icon>
    </button>
    <ul
      #notificationsDropdown
      class="dropdown-menu dropdown-notifications mt-3"
      aria-labelledby="notifications"
      [class]="notificationsDropdownOpen ? 'd-block' : 'd-none'"
    >
      <li>
        <p class="text-muted small mb-0 text-center p-2">
          {{ "NOTIFICATIONS.NO_NOTIFICATIONS" | translate }}
        </p>
      </li>
    </ul>
  </div>
  <button
    *ngIf="menuType === 'defaultHamburger'"
    type="button"
    class="btn btn-primary btn-circle d-md-none px-0 btn-hamburger-menu"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasWithBackdrop"
    aria-controls="offcanvasWithBackdrop"
  >
    <app-icon name="menu"></app-icon>
  </button>
</div>